import React from 'react'
import { FaFacebook, FaInstagram, FaGithub, FaLinkedin } from 'react-icons/fa'
import { AiFillCopyrightCircle } from 'react-icons/ai'
import logo from './logo.svg'
import {animateScroll as scroll} from 'react-scroll'

const Footer = () => {

    const toggleHome=()=>{
        scroll.scrollToTop();
    }


    return (
        <footer className="footer">
            <div className="footer_heading">
                <h2>This is Mynfo {new Date().getFullYear()}<AiFillCopyrightCircle /></h2>
            </div>
            <div className="footer_info">
                <img onClick={toggleHome} src={logo} alt="mynfo_logo" />
                <div className="footer_details">
                    <div className="footer_desc">
                       <big>S</big>o, how much did you liked the website ?  Leave a comment in my social media by #tagging me and do check out other places too where i deploy these builds.
                    </div>
                    <div className="footer_buttons">
                        <a href="//www.linkedin.com/in/deep-jyoti-160a22144/">
                            <div className="linkedin"><FaLinkedin /></div>
                        </a>
                        <a href="//github.com/djkumar143/">
                            <div className="github"><FaGithub /></div>
                        </a>
                        <a href="//www.facebook.com/djkumar143/">
                            <div className="facebook"><FaFacebook /></div>
                        </a>
                        <a href="//www.instagram.com/dare_to_hug/">
                            <div className="instagram"><FaInstagram /></div>
                        </a>
                    </div>
                </div>
            </div>


        </footer>
    )
}

export default Footer
